// ==========================
// Version 5 - firebase.js
// - Initializes Firebase App Check with reCAPTCHA Enterprise when configured
// - Skips browser-only verification services during localhost SEO pre-rendering
// ==========================

import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";
import { getAnalytics, isSupported as analyticsSupported } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
const appCheckSiteKey = process.env.REACT_APP_RECAPTCHA_ENTERPRISE_SITE_KEY;
const isLocalPrerender =
  typeof window !== "undefined" &&
  ["localhost", "127.0.0.1", "::1"].includes(window.location.hostname) &&
  new URLSearchParams(window.location.search).get("bwak_prerender") === "1";

export const appCheck =
  typeof window !== "undefined" && appCheckSiteKey && !isLocalPrerender
    ? initializeAppCheck(app, {
        provider: new ReCaptchaEnterpriseProvider(appCheckSiteKey),
        isTokenAutoRefreshEnabled: true,
      })
    : null;

// Analytics (guarded so it doesn't blow up in unsupported envs)
if (!isLocalPrerender) {
  analyticsSupported().then((ok) => {
    if (ok) getAnalytics(app);
  });
}

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// 👇 Export the Google provider expected by Register.js / Login.js
export const googleProvider = new GoogleAuthProvider();
// optional: force account picker every time
googleProvider.setCustomParameters({ prompt: "select_account" });

export default app;

// ==========================
// End Version 4 - firebase.js
// ==========================
